import { TRootState } from "../models"

const initialState = {
  get: () => {
    const initalState = localStorage.getItem("states-ahli")
    return initalState ? JSON.parse(initalState) : {}
  },
  set: (state: Partial<TRootState>) => {
    localStorage.setItem("states-ahli", JSON.stringify(state))
  },
}

export default initialState
